import { render } from "./previewDialog.vue?vue&type=template&id=4ebcdb7a&scoped=true&lang=pug"
import script from "./previewDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./previewDialog.vue?vue&type=script&setup=true&lang=js"

import "./previewDialog.vue?vue&type=style&index=0&id=4ebcdb7a&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-4ebcdb7a"

export default script